<template>
  <div>
    <a-card>
      <div class="table-title">
      </div>
      <a-form layout="inline" ref="searchForm" :model="form.searchForm" style="margin-bottom: 20px;">
        <a-form-item label="任务类型" name="takType">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.takType"
            :options="optData.taskTypeOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="子任务状态" name="status">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.status"
            :options="optData.taskStatusOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="关键字" name="keywords">
          <a-input style="width: 200px" ref="keywords" placeholder="根据总任务编号/名称查询" v-model:value="form.searchForm.keywords" autocomplete="off">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
        </a-form-item>
      </a-form>
      <a-table :dataSource="task.list" :columns="columns" :pagination="false">
        <template v-slot:taskType="{ record }">
            {{ statusTrans(record.type, taskType) }}
        </template>
        <template v-slot:taskStatus="{ record }">
          <div v-if="record.isParent">  <!-- 总任务 -->                              
            {{ statusTrans(record.state, taskSatus) }}
          </div>
          <div v-else>  <!-- 子任务 -->
            {{ statusTrans(record.state, subtaskSatus) }}
          </div>
        </template>
        <template v-slot:action="{ record }">
          <div>
            <div v-if="record.state == 'to_be_inspected'">  <!-- 待质检 -->
              <span class="gap-btn">
                <a @click="openSubDetail(record)">查看</a>
              </span>
              <span class="gap-btn">
                <a-popconfirm
                title="请确认在质检前已阅读标注说明,若未阅读标注说明，请于查看界面下载。"
                ok-text="确认"
                cancel-text="取消"
                @confirm="taskInspect(record)"
              >
                <a href="#">质检</a>
              </a-popconfirm>
              </span>
            </div>
            <div v-else-if="record.state == 'in_inspecting'">  <!-- 质检中 -->
              <span class="gap-btn">
                <a @click="openSubDetail(record)">查看</a>
              </span>
              <span class="gap-btn">
                <a-popconfirm
                title="请确认在质检前已阅读标注说明,若未阅读标注说明，请于查看界面下载。"
                ok-text="确认"
                cancel-text="取消"
                @confirm="taskInspect(record)"
              >
                <a href="#">质检</a>
              </a-popconfirm>
              </span>
            </div>
            <div v-else> 
              <span class="gap-btn">
                <a @click="openSubDetail(record)">查看</a>
              </span>
            </div>
          </div>

        </template>
      </a-table>
      <div class="mt20">
        <a-pagination
        v-model:current="task.page.num"
        show-quick-jumper
        :pageSize=task.page.size
        :total="task.page.total"
        :show-total="total => `共 ${total} 条`"
        @change="getTaskList"
      ></a-pagination>
      </div>
    </a-card>
    
    
  </div>
</template>


<script>
const columns = [
  {
    title: '任务编号',
    dataIndex: 'number'
  },
  {
    title: '任务名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'type',
    slots: { customRender: 'taskType' }

  },
  {
    title: '任务状态',
    dataIndex: 'state',
    slots: { customRender: 'taskStatus' }
   

  },
  {
    title: '发布人',
    dataIndex: 'createUserName',

  },

  {
    title: '发布时间',
    dataIndex: 'createTime',
   
  },
  {
    title: '要求完成时间',
    dataIndex: 'endTime',

  },
  {
    title: '操作',
    slots: { customRender: 'action' }

  }
]

import {reactive, onMounted} from "vue";
import {useRoute, useRouter} from 'vue-router'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'
import {statusToCn} from '@/filters'

import {subpageForServer, inspectStart,teamMembers} from '@/api/taskRelease'


export default{
  components:{
    
  },
  setup(){
    const router = useRouter()
    const route = useRoute()
    let task = reactive({
      list:[],
      taskFormVisible:false,
      fromType:'creat',
      page:{
        num:1,
        size:10,
        total:0
      },
      taskData:[]
    })

    let htmlstr = '请确认在质检前已阅读标注说明,若未阅读标注说明，请于查看界面下载。'


    function openSubDetail(record){
      if(record.labelType == 'online'){
        localStorage.setItem('subTask',JSON.stringify([{id:record.id,number:record.number}]))
        router.push(`/labelDetail?form=sub&taskId=${record.taskId}&subTaskId=${record.id}&type=view`)  //&page=inspect
      }else{
        router.push(`/taskDetail?taskId=${record.taskId}`)
      }
      return
    }

    let store = useStore()
    let {taskSatus,subtaskSatus,taskType } = store

    function statusTrans(state, stateObj){
      return statusToCn(state, stateObj)
    }
  
    
    let form = reactive({
      searchForm:{
        takType:'',
        status:'',
        keywords:'',
      }
    })
    
    let optData = reactive({
      taskTypeOpt:[{label:'全部',value:''}],
      taskStatusOpt:[{label:'全部',value:''}],
    })




    function initData(){
      try {
        for(let prop in taskType){
          optData.taskTypeOpt.push({
            value:prop,
            label:taskType[prop]
          }) 
        }

        for(let prop in subtaskSatus){
          optData.taskStatusOpt.push({
            value:prop,
            label:subtaskSatus[prop]
          }) 
        }

      } catch (error) {
        
      }
    }

    //  搜索
    const search = ()=>{
      task.page.num = 1
      getTaskList()
    }

    //  任务列表  
    const getTaskList = async ()=>{
      task.list = []
      let params = {
        //groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
        keyword:form.searchForm.keywords,
        pageNum:task.page.num,
        pageSize:task.page.size,
        states: form.searchForm.status,
        type:form.searchForm.takType,
        opType:'inspect',
        //visibility:'',
      }
      const {data:res} = await subpageForServer(params)
        const list = [...res.data.records]
        task.list = list
        task.page.total = res.data.total

    }


    onMounted(() => {
      getTaskList()
      initData()
    })

    let member = {
      list:[]
    }

     // 获取成员信息
     async function getMember(record){
      let params = {
        labelTaskSubId:record.id,
        inspector:'',
        labeler:''
      }
      const {data:res} = await teamMembers(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.success(res.msg)
      }
     
    }

    // 质检
    async function taskInspect(record){
      localStorage.setItem('subTask',JSON.stringify([{id:record.id,number:record.number}]))
      let params = {
        labelTaskSubId:record.id
      }
      inspectStart(params).then(()=>{
        router.push(`/labelDetail?form=sub&page=inspect&taskId=${record.taskId}&subTaskId=${record.id}`)
      })
      
      return
     
    }


    return{   
      form,
      columns,
      taskType,
      taskSatus,
      subtaskSatus,
      statusToCn,
      htmlstr,
      getTaskList,
      task,
      statusTrans,
      
      optData,
      search,
      openSubDetail,
      taskInspect
    }
  }
}
</script>


<style>

</style>
